import { LoadingScreen, LogoOnlyLayout, PublicLayout } from '@bakerweb/layouts';
import { lazy, Suspense } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';

const Loadable = (Component: any) => (props: any) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.includes('/loans');

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: 'fixed'
            })
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/home" replace />,
      index: true
    },
    {
      path: 'home',
      element: <PublicLayout />,
      children: [
        {
          element: <LoansHomePage />,
          index: true
        }
      ]
    },

    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}

const NotFound = Loadable(lazy(() => import('../pages/404Page')));
const LoansHomePage = Loadable(lazy(() => import('../pages/LoansHomePage')));
